import { Feedbacks } from "./feedbacks_tab/Feedbacks"
import { FeedbackTopics } from "./topics_tab/FeedbackTopics"
import { HashTabSection } from "../../components/Helpers"

export function FeedbacksContainer() {
  return (
    <HashTabSection
      defaultTab="feedbacks"
      tabItems={[
        { id: "feedbacks", label: "Feedbacks" },
        { id: "topics", label: "Topics" },
      ]}
      tabContent={{
        feedbacks: <Feedbacks />,
        topics: <FeedbackTopics />,
      }}
    />
  )
}
